import { useEffect, useState } from 'react';
import Client from 'shopify-buy';
import map from 'lodash/map';
import uniq from 'lodash/uniq';
import sortBy from 'lodash/sortBy';

const productPrice = ({ variants }) => {
  const prices = uniq(map(variants, 'price'));
  if (prices.length === 1) {
    return `${formatPriceInCurrency(prices[0].amount)}`;
  }
  const lowestPrice = sortBy(prices, price => parseInt(price.amount, 10))[0];
  return `From ${formatPriceInCurrency(lowestPrice.amount)}`;
};

const formatPriceInCurrency = number => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(
  number,
);

const useShopify = (config, collectionId, count, linkRoot = 'https://shop.spyscape.com') => {
  const [products, setProducts] = useState([]);
  const [shopNowLink, setShopNowLink] = useState(undefined);

  useEffect(() => {
    const client = Client.buildClient(config);

    const productToObject = product => ({
      id: product.id,
      imageUrl: product.images[0].src,
      linkUrl: `${linkRoot}/products/${product.handle}`,
      title: product.title,
      price: productPrice(product),
    });

    client.collection.fetchWithProducts(collectionId, { productsFirst: 20 }).then((response) => {
      setShopNowLink(`${linkRoot}/collections/${response.handle}`);
      setProducts(map(response.products.slice(0, count), productToObject));
    });
  }, [config, collectionId, count, linkRoot]);

  return [products, shopNowLink];
};

export default useShopify;
